import React, { useState } from 'react';
import { CheckIcon, XIcon, ShieldCheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQAccordion } from '../components/FAQAccordion';
import { SocialProofPopup } from '../components/SocialProofPopup';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/vyfApAcnNGGxHbFxSQwrTG/Mockup.png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/jFNxg95HMggTTRsYAaGmCg/Mockup_-_Bono_1.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/kxjUqme1jRwNLHDN1Y98HA/Mockup_-_Bono_2.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/6cPmFsb6bpUsRFV3mF3xcB/Mockup_-_Bono_3.png';
const PREVIEW_PAGES: string[] = ['https://cdn.magicpatterns.com/uploads/9LKrGiLFgQcGrf2rxennqM/Hoja_1.jpg', 'https://cdn.magicpatterns.com/uploads/2ZU7ameBHi2Kkixubp5bP5/Hoja_2.jpg', 'https://cdn.magicpatterns.com/uploads/2G4qFxFqQySFi6wFmmvyeH/Hoja_3.jpg', 'https://cdn.magicpatterns.com/uploads/djmZ97ANWeGumDhH8Svahu/Hoja_4.jpg', 'https://cdn.magicpatterns.com/uploads/bLnZ8RK68PW6RXhAuM3n7j/Hoja_5.jpg', 'https://cdn.magicpatterns.com/uploads/kMqc4GJz344GiRHntuA56U/Hoja_6.jpg'];
const CHECKOUT_LINK = 'https://checkout.tumundoglobal.online/cart/45190695944383:1';
const SECTION_LINK = '#compra';
export function SalesPage() {
  const [currentPage, setCurrentPage] = useState(0);
  const nextPage = () => {
    setCurrentPage(prev => (prev + 1) % PREVIEW_PAGES.length);
  };
  const prevPage = () => {
    setCurrentPage(prev => (prev - 1 + PREVIEW_PAGES.length) % PREVIEW_PAGES.length);
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20" data-id="element-35">
      <CountdownTimer data-id="element-36" />
      <SocialProofPopup data-id="element-37" />

      {/* HERO SECTION */}
      <section className="pt-8 pb-12 px-4 md:pt-12 md:pb-20 bg-gradient-to-b from-white to-gray-50" data-id="element-38">
        <div className="max-w-4xl mx-auto text-center" data-id="element-39">
          <div className="inline-flex items-center justify-center bg-green-100 text-green-700 px-6 py-2 rounded-full mb-6" data-id="element-40">
            <span className="text-sm md:text-base font-medium uppercase tracking-wide" data-id="element-41">
              PARA MAMÁS DE BEBÉS DE 6 A 36 MESES
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-black tracking-tight text-gray-900 mb-8 leading-tight" data-id="element-42">
            Alimentá a tu bebé con seguridad desde los 6 meses hasta los 3 años
            sin miedo ni improvisación
          </h1>

          <div className="mb-6" data-id="element-43">
            <a href={SECTION_LINK} data-id="element-44">
              <img src={PRODUCT_IMAGE} alt="Kit Recetas para Bebé" className="w-full max-w-lg mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-45" />
            </a>
          </div>

          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-46">
            Un sistema paso a paso con 350+ recetas organizadas por edad, cortes
            seguros y menús listos para que nunca más tengas dudas sobre qué
            cocinarle a tu bebé.
          </p>

          <CTAButton data-id="element-47">👉 SÍ, QUIERO EL SISTEMA AHORA</CTAButton>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-48">
        <div className="max-w-3xl mx-auto" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-50">
            Si querés alimentar bien a tu bebé… pero por dentro estás llena de
            dudas, dejame preguntarte algo honesto:
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-51">
            <p className="font-medium" data-id="element-52">
              ¿Te pasa que cada día te preguntás qué cocinarle?
            </p>
            <p className="font-medium" data-id="element-53">
              ¿Buscás recetas durante horas y terminás más confundida?
            </p>
            <p className="font-medium" data-id="element-54">¿Te da miedo que se atragante?</p>
            <p className="font-medium" data-id="element-55">
              ¿Te preocupa no introducir bien los alimentos?
            </p>
            <p className="font-medium" data-id="element-56">
              ¿Sentís que otras mamás saben más que vos?
            </p>
            <p className="font-medium" data-id="element-57">
              ¿Te angustia equivocarte justo en algo tan importante?
            </p>

            <p className="text-xl font-bold text-gray-900 mt-8 text-center italic" data-id="element-58">
              Porque cuando se trata de tu bebé, cualquier duda se siente
              enorme.
            </p>

            <p className="text-xl font-bold text-gray-900 mt-8" data-id="element-59">
              No estás exagerando. No estás siendo dramática. Y no te falta
              información.
            </p>
            <p data-id="element-60">Pero algo sí está pasando.</p>
            <p data-id="element-61">Y no es que no seas capaz.</p>
            <p className="text-center font-bold text-2xl mt-8 border-l-4 border-[#dc2626] pl-4 py-2 bg-red-50" data-id="element-62">
              La verdad es simple: nadie te enseñó cómo hacerlo paso a paso.
            </p>
          </div>

          <div className="mt-12" data-id="element-63">
            <CTAButton data-id="element-64">👉 QUIERO ALIMENTAR A MI BEBÉ CON SEGURIDAD</CTAButton>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-65">
        <div className="max-w-4xl mx-auto" data-id="element-66">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-yellow-400" data-id="element-67">
            El verdadero problema que nadie te explica sobre alimentar a tu bebé
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-68">
            <div className="space-y-4" data-id="element-69">
              <p className="text-xl font-medium mb-6" data-id="element-70">
                Si esto te pasa, probablemente te resulte familiar:
              </p>
              <ul className="space-y-4" data-id="element-71">
                <li className="flex items-start gap-3" data-id="element-72">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-73" />
                  <span className="text-lg" data-id="element-74">
                    Vivís improvisando cada comida
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-75">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-76" />
                  <span className="text-lg" data-id="element-77">
                    Guardás capturas de recetas que nunca organizás
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-78">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-79" />
                  <span className="text-lg" data-id="element-80">
                    Te da miedo introducir ciertos alimentos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-81">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-82" />
                  <span className="text-lg" data-id="element-83">
                    No sabés cómo cortarlos correctamente
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-84">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-85" />
                  <span className="text-lg" data-id="element-86">
                    No tenés claro qué corresponde según la edad
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-87">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-88" />
                  <span className="text-lg" data-id="element-89">
                    Sentís presión por "hacerlo bien"
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-90">
              <p className="text-lg mb-6" data-id="element-91">
                Y lo peor es esa sensación interna de:
              </p>
              <p className="text-2xl font-bold italic text-gray-300 mb-8" data-id="element-92">
                "Quiero hacerlo bien… pero no sé si lo estoy haciendo
                correctamente."
              </p>

              <div className="space-y-2 font-bold text-red-400 text-xl" data-id="element-93">
                <p data-id="element-94">❌ No es que seas inexperta.</p>
                <p data-id="element-95">❌ No es que necesites más fuerza de voluntad.</p>
                <p data-id="element-96">❌ No es que tu bebé sea difícil.</p>
              </div>

              <p className="mt-6 text-gray-300" data-id="element-97">
                La alimentación complementaria no es intuitiva cuando nadie te
                da estructura.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-98">
            <p className="text-xl mb-8" data-id="element-99">
              👉 El problema no es que te falten recetas.
            </p>
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 max-w-3xl mx-auto mb-8" data-id="element-100">
              <h3 className="text-xl font-bold text-red-400 mb-4" data-id="element-101">
                Tu problema no es cocinar.
              </h3>
              <p className="text-gray-300" data-id="element-102">
                Es no tener un sistema claro que te diga qué ofrecer en cada
                etapa.
              </p>
            </div>
            <p className="text-2xl font-bold text-[#22c55e]" data-id="element-103">
              👉 El Sistema de Alimentación Segura para Bebés nace para eliminar
              esa improvisación.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-104">
        <div className="max-w-5xl mx-auto" data-id="element-105">
          <div className="text-center mb-16" data-id="element-106">
            <span className="bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-107">
              ✅ LA SOLUCIÓN
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-6 mb-4" data-id="element-108">
              El Sistema de Alimentación Segura para Bebés
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-109">
              Un método práctico, organizado y progresivo para saber exactamente
              qué ofrecerle a tu bebé en cada etapa.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-110">
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-111">
              <h3 className="text-2xl font-bold mb-6" data-id="element-112">Diseñado para que:</h3>
              <ul className="space-y-4" data-id="element-113">
                <li className="flex items-center gap-3" data-id="element-114">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-115" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-116">
                    Sepas exactamente qué ofrecer según la edad
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-117">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-118" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-119">
                    Tengas cortes seguros sin miedo
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-120">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-121" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-122">
                    Introduzcas alérgenos con tranquilidad
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-123">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-124" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-125">
                    Evites improvisar cada día
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-126">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-127" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-128">
                    Acompañes el desarrollo real de tu bebé
                  </span>
                </li>
              </ul>
            </div>

            <div className="flex flex-col justify-center items-center text-center p-8 bg-gray-50 rounded-2xl border border-gray-100" data-id="element-129">
              <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-130">
                Así de simple:
              </h3>
              <div className="space-y-6 text-xl font-bold text-gray-800" data-id="element-131">
                <div className="flex items-start gap-4" data-id="element-132">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-133">
                    1
                  </span>
                  <span className="text-left" data-id="element-134">
                    Abrís el tomo correspondiente a la edad de tu bebé
                  </span>
                </div>
                <div className="flex items-start gap-4" data-id="element-135">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-136">
                    2
                  </span>
                  <span className="text-left" data-id="element-137">Elegís la receta</span>
                </div>
                <div className="flex items-start gap-4" data-id="element-138">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-139">
                    3
                  </span>
                  <span className="text-left" data-id="element-140">Cocinás con seguridad</span>
                </div>
              </div>
              <p className="mt-8 text-lg text-gray-600 italic" data-id="element-141">
                Sin dudas. Sin caos. Sin buscar en 10 blogs distintos.
              </p>
            </div>
          </div>

          <CTAButton data-id="element-142">👉 QUIERO EMPEZAR HOY</CTAButton>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-143">
        <div className="max-w-5xl mx-auto" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-145">
            📘 ¿QUÉ INCLUYE EL SISTEMA?
          </h2>
          <p className="text-center text-xl text-gray-600 mb-12" data-id="element-146">
            📦 6 TOMOS ORGANIZADOS SEGÚN LA EDAD DE TU BEBÉ
          </p>

          <p className="text-center text-lg font-bold text-gray-800 mb-12 max-w-3xl mx-auto" data-id="element-147">
            Más de 350 recetas organizadas en 6 tomos que acompañan cada etapa
            del desarrollo de tu bebé.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-148">
            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-149">
              <div className="text-4xl mb-4" data-id="element-150">📗</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-151">
                Tomo 1 — 6–8 meses | Primeros Sabores
              </h3>
              <p className="text-gray-600" data-id="element-152">
                Aprendé cómo empezar la alimentación complementaria de forma
                segura, con texturas adecuadas y primeros alimentos fáciles de
                aceptar.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-153">
              <div className="text-4xl mb-4" data-id="element-154">📘</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-155">
                Tomo 2 — 8–10 meses | Más Variedad
              </h3>
              <p className="text-gray-600" data-id="element-156">
                Incorporá nuevos alimentos y combinaciones simples para ampliar
                la dieta de tu bebé sin confusión.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-157">
              <div className="text-4xl mb-4" data-id="element-158">📙</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-159">
                Tomo 3 — 10–12 meses | Más Autonomía
              </h3>
              <p className="text-gray-600" data-id="element-160">
                Transición hacia comidas más completas mientras tu bebé
                desarrolla habilidades para comer solo.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-161">
              <div className="text-4xl mb-4" data-id="element-162">📕</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-163">
                Tomo 4 — 12–18 meses | Comer en Familia
              </h3>
              <p className="text-gray-600" data-id="element-164">
                Platos saludables adaptados para que tu bebé empiece a comer lo
                mismo que la familia.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-165">
              <div className="text-4xl mb-4" data-id="element-166">📒</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-167">
                Tomo 5 — 18–36 meses | Etapa Selectiva
              </h3>
              <p className="text-gray-600" data-id="element-168">
                Estrategias prácticas para manejar el rechazo de alimentos y
                ampliar el repertorio de comidas.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-169">
              <div className="text-4xl mb-4" data-id="element-170">📓</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-171">
                Tomo 6 — Organización Inteligente
              </h3>
              <p className="text-gray-600" data-id="element-172">
                Aprendé a planificar menús y preparar comidas de la semana para
                evitar improvisar todos los días.
              </p>
            </a>
          </div>

          <div className="mt-12 bg-white p-6 rounded-xl border border-gray-200 max-w-3xl mx-auto" data-id="element-173">
            <ul className="space-y-3 text-lg" data-id="element-174">
              <li className="flex items-center gap-3" data-id="element-175">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-176" />
                <span className="font-medium" data-id="element-177">
                  Más de 350 recetas reales probadas con bebés
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-178">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-179" />
                <span className="font-medium" data-id="element-180">Organizadas por edad</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-181">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-182" />
                <span className="font-medium" data-id="element-183">Sin sal añadida</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-184">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-185" />
                <span className="font-medium" data-id="element-186">Sin azúcar refinada</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-187">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-188" />
                <span className="font-medium" data-id="element-189">
                  Con cortes seguros explicados
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-190">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-191" />
                <span className="font-medium" data-id="element-192">
                  Pensadas para mamás con poco tiempo
                </span>
              </li>
            </ul>
          </div>

          <p className="text-center text-lg font-medium mt-12 text-gray-700" data-id="element-193">
            👉 Todo estructurado para que sepas qué hacer y cuándo hacerlo.
          </p>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-194">
        <div className="max-w-4xl mx-auto" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-196">
            La diferencia entre improvisar… y tener un sistema
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-197">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-198">
              <h3 className="text-xl font-bold text-red-800 mb-6 text-center" data-id="element-199">
                Antes del sistema
              </h3>
              <ul className="space-y-4" data-id="element-200">
                <li className="flex items-center gap-3" data-id="element-201">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-202" />
                  <span className="text-gray-700" data-id="element-203">Improvisación diaria</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-204">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-205" />
                  <span className="text-gray-700" data-id="element-206">
                    Miedo a atragantamientos
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-207">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-208" />
                  <span className="text-gray-700" data-id="element-209">Dudas con alergias</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-210">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-211" />
                  <span className="text-gray-700" data-id="element-212">Estrés al planificar</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-213">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-214" />
                  <span className="text-gray-700" data-id="element-215">Peleas en la mesa</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-216">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-217" />
                  <span className="text-gray-700" data-id="element-218">
                    Sensación de no saber si lo haces bien
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg transform md:-translate-y-4" data-id="element-219">
              <h3 className="text-xl font-bold text-green-800 mb-6 text-center" data-id="element-220">
                Después del sistema
              </h3>
              <ul className="space-y-4" data-id="element-221">
                <li className="flex items-center gap-3" data-id="element-222">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-223" />
                  <span className="font-bold text-gray-800" data-id="element-224">
                    Seguridad real
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-225">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-226" />
                  <span className="font-bold text-gray-800" data-id="element-227">
                    Cortes claros y seguros
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-228">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-229" />
                  <span className="font-bold text-gray-800" data-id="element-230">
                    Introducción ordenada de alimentos
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-231">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-232" />
                  <span className="font-bold text-gray-800" data-id="element-233">Menús listos</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-234">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-235" />
                  <span className="font-bold text-gray-800" data-id="element-236">
                    Bebé que aprende a comer solo
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-237">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-238" />
                  <span className="font-bold text-gray-800" data-id="element-239">
                    Tranquilidad como mamá
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-[#0f172a] text-white" data-id="element-240">
        <div className="max-w-5xl mx-auto" data-id="element-241">
          <div className="text-center mb-12" data-id="element-242">
            <span className="bg-yellow-400 text-black px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse" data-id="element-243">
              🎁 BONOS ESPECIALES INCLUIDOS HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-4" data-id="element-244">
              Además del sistema, hoy recibes 3 guías extra para hacerlo con
              total tranquilidad
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-245">
            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-246">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-247">
                <img src={BONUS_1_IMAGE} alt="Bono 1 - Noches Tranquilas" className="w-full h-full object-contain drop-shadow-xl" data-id="element-248" />
              </div>
              <p className="text-gray-400 text-sm mb-2" data-id="element-249">
                Valor:{' '}
                <span className="line-through font-bold" data-id="element-250">$27.000 ARS</span>
              </p>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-251">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-252">
                🎁 Bono #1 — Noches Tranquilas
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-253">
                Guía práctica para mejorar el descanso del bebé. Porque
                alimentación y sueño van de la mano.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-254">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-255">
                <img src={BONUS_2_IMAGE} alt="Bono 2 - Alérgenos Seguros" className="w-full h-full object-contain drop-shadow-xl" data-id="element-256" />
              </div>
              <p className="text-gray-400 text-sm mb-2" data-id="element-257">
                Valor:{' '}
                <span className="line-through font-bold" data-id="element-258">$21.000 ARS</span>
              </p>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-259">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-260">
                🎁 Bono #2 — Alérgenos Seguros
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-261">
                Qué ofrecer. Cuándo ofrecer. Qué observar. Qué hacer ante una
                reacción.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-262">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-263">
                <img src={BONUS_3_IMAGE} alt="Bono 3 - Guía de Cortes Seguros BLW" className="w-full h-full object-contain drop-shadow-xl" data-id="element-264" />
              </div>
              <p className="text-gray-400 text-sm mb-2" data-id="element-265">
                Valor:{' '}
                <span className="line-through font-bold" data-id="element-266">$17.000 ARS</span>
              </p>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-267">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-268">
                🎁 Bono #3 — Guía de Cortes Seguros BLW
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-269">
                Cómo cortar cada alimento según edad. Evita sustos innecesarios
                y gana seguridad real.
              </p>
            </a>
          </div>

          <div className="mt-12 text-center space-y-2 text-lg font-medium" data-id="element-270">
            <p data-id="element-271">👉 Los tomos te dicen qué cocinar.</p>
            <p data-id="element-272">👉 Los bonos te muestran cómo hacerlo con seguridad.</p>
            <p className="mt-4 text-gray-300" data-id="element-273">
              Por eso no es solo un recetario.
            </p>
            <p className="text-yellow-400 font-bold text-xl mt-2" data-id="element-274">
              Es un sistema completo para alimentar a tu bebé con tranquilidad.
            </p>
          </div>

          <div className="mt-12" data-id="element-275">
            <CTAButton data-id="element-276">👉 QUIERO MIS BONOS AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* OFFER STACK SECTION */}
      <section id="compra" className="py-16 px-4 bg-gradient-to-b from-gray-900 to-gray-800" data-id="element-277">
        <div className="max-w-4xl mx-auto" data-id="element-278">
          <div className="text-center mb-10" data-id="element-279">
            <span className="bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse inline-block mb-4" data-id="element-280">
              ⏰ OFERTA ESPECIAL
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase leading-tight" data-id="element-281">
              ACCESO ESPECIAL POR TIEMPO LIMITADO
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-282">
            <h3 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-283">
              📦 Lo que recibes hoy:
            </h3>

            <div className="space-y-4 mb-10" data-id="element-284">
              <div className="flex items-center justify-between text-lg md:text-xl border-b border-gray-200 pb-3" data-id="element-285">
                <div className="flex items-center gap-3" data-id="element-286">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-287" />
                  <span className="font-bold text-gray-800" data-id="element-288">
                    6 tomos completos
                  </span>
                </div>
                <span className="text-gray-500 font-medium" data-id="element-289">$49.000 ARS</span>
              </div>
              <div className="flex items-center justify-between text-lg md:text-xl border-b border-gray-200 pb-3" data-id="element-290">
                <div className="flex items-center gap-3" data-id="element-291">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-292" />
                  <span className="font-bold text-gray-800" data-id="element-293">
                    Bono "Noches Tranquilas"
                  </span>
                </div>
                <span className="text-gray-500 font-medium" data-id="element-294">$27.000 ARS</span>
              </div>
              <div className="flex items-center justify-between text-lg md:text-xl border-b border-gray-200 pb-3" data-id="element-295">
                <div className="flex items-center gap-3" data-id="element-296">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-297" />
                  <span className="font-bold text-gray-800" data-id="element-298">
                    Bono "Alérgenos Seguros"
                  </span>
                </div>
                <span className="text-gray-500 font-medium" data-id="element-299">$21.000 ARS</span>
              </div>
              <div className="flex items-center justify-between text-lg md:text-xl border-b border-gray-200 pb-3" data-id="element-300">
                <div className="flex items-center gap-3" data-id="element-301">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-302" />
                  <span className="font-bold text-gray-800" data-id="element-303">
                    Bono "Guía de Cortes BLW"
                  </span>
                </div>
                <span className="text-gray-500 font-medium" data-id="element-304">$17.000 ARS</span>
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-305">
              <p className="text-gray-500 text-xl mb-2" data-id="element-306">
                Valor total del sistema:{' '}
                <span className="line-through decoration-red-500 decoration-2 font-bold" data-id="element-307">
                  $114.000 ARS
                </span>
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-308">
              <p className="text-gray-500 text-lg mb-2" data-id="element-309"></p>
              <p className="text-5xl md:text-7xl font-black text-[#22c55e]" data-id="element-310">
                🔥 19.990 ARS
              </p>
              <p className="text-gray-800 mt-2 font-bold text-lg" data-id="element-311">
                Un solo pago. Sin suscripciones.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center w-full" data-id="element-312">
              <a href={CHECKOUT_LINK} className="relative group flex items-center justify-center gap-2 w-full md:max-w-2xl px-6 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1 text-xl md:text-2xl font-bold uppercase tracking-normal" data-id="element-313">
                👉 OBTENER EL SISTEMA AHORA
              </a>
              <div className="flex flex-wrap items-center justify-center gap-4 mt-6 text-sm text-gray-500" data-id="element-314">
                <span data-id="element-315">🔒 Pago seguro</span>
                <span data-id="element-316">•</span>
                <span data-id="element-317">⚡ Acceso inmediato</span>
                <span data-id="element-318">•</span>
                <span data-id="element-319">🛡 Garantía de 7 días</span>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col md:flex-row items-center gap-6 bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20" data-id="element-320">
            <ShieldCheckIcon className="w-16 h-16 text-yellow-400 flex-shrink-0" data-id="element-321" />
            <div className="text-center md:text-left" data-id="element-322">
              <h3 className="text-xl font-bold mb-2 text-white" data-id="element-323">
                Garantía de 7 días sin riesgo
              </h3>
              <p className="text-gray-300" data-id="element-324">
                Pruébalo durante 7 días. Si no sientes más seguridad y claridad
                al planificar las comidas, te devolvemos el 100% del dinero. Sin
                preguntas. Sin complicaciones.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PREVIEW PAGES SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-325">
        <div className="max-w-4xl mx-auto" data-id="element-326">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-327">
            📖 Revisa algunas hojas
          </h2>
          <p className="text-center text-gray-600 mb-10" data-id="element-328">
            Mira una muestra real de cómo está organizado el contenido.
          </p>

          <div className="relative flex items-center justify-center gap-4" data-id="element-329">
            {/* Left arrow */}
            <button onClick={prevPage} className="flex-shrink-0 w-12 h-12 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center shadow-md hover:bg-gray-50 hover:border-gray-300 transition-all z-10" aria-label="Página anterior" data-id="element-330">
              <ChevronLeftIcon className="w-6 h-6 text-gray-700" data-id="element-331" />
            </button>

            {/* Image */}
            <div className="flex-1 max-w-2xl" data-id="element-332">
              <img key={currentPage} src={PREVIEW_PAGES[currentPage]} alt={`Hoja ${currentPage + 1}`} className="w-full rounded-2xl shadow-xl border border-gray-100" data-id="element-333" />
              {/* Dots */}
              <div className="flex justify-center gap-2 mt-4" data-id="element-334">
                {PREVIEW_PAGES.map((_, i) => <button key={i} onClick={() => setCurrentPage(i)} className={`w-2.5 h-2.5 rounded-full transition-all ${i === currentPage ? 'bg-green-500 w-6' : 'bg-gray-300'}`} aria-label={`Ir a hoja ${i + 1}`} data-id="element-335" />)}
              </div>
            </div>

            {/* Right arrow */}
            <button onClick={nextPage} className="flex-shrink-0 w-12 h-12 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center shadow-md hover:bg-gray-50 hover:border-gray-300 transition-all z-10" aria-label="Página siguiente" data-id="element-336">
              <ChevronRightIcon className="w-6 h-6 text-gray-700" data-id="element-337" />
            </button>
          </div>

          <p className="text-center text-sm text-gray-500 mt-4" data-id="element-338">
            {currentPage + 1} / {PREVIEW_PAGES.length}
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-339">
        <div className="max-w-6xl mx-auto" data-id="element-340">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-341">
            Lo que dicen las mamás que ya usan el sistema
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-342">
            <TestimonialCard name="Carolina" age={32} location="Buenos Aires" quote="Antes vivía con miedo constante de que se atragantara. Con el sistema aprendí los cortes seguros y ahora cocino con tranquilidad. Mi bebé come de todo." highlight="ahora cocino con tranquilidad" data-id="element-343" />
            <TestimonialCard name="Sofía" age={28} location="Córdoba" quote="Pasé de buscar recetas en Instagram cada día a tener todo organizado por edad. Me ahorro horas de estrés y mi hija está súper bien alimentada." highlight="tener todo organizado por edad" data-id="element-344" />
            <TestimonialCard name="Valentina" age={35} location="Rosario" quote="Lo mejor es que no tengo que improvisar más. Abro el tomo, elijo la receta y listo. Siento que finalmente sé lo que estoy haciendo." highlight="finalmente sé lo que estoy haciendo" data-id="element-345" />
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-6" data-id="element-346">
            <TestimonialCard name="Lucía" age={30} location="Mendoza" quote="Los bonos de alérgenos y cortes seguros me salvaron. Introduje huevo, pescado y frutos secos sin miedo gracias a las instrucciones claras." highlight="Introduje huevo, pescado y frutos secos sin miedo" data-id="element-347" />
            <TestimonialCard name="Martina" age={27} location="La Plata" quote="Mi bebé está en la etapa selectiva y las recetas del tomo 5 funcionan increíble. Come verduras que antes rechazaba. Estoy feliz." highlight="Come verduras que antes rechazaba" data-id="element-348" />
            <TestimonialCard name="Camila" age={33} location="Santa Fe" quote="Trabajo full time y el batch cooking del tomo 6 cambió mi vida. Cocino una vez y tengo comida lista para toda la semana. Súper práctico." highlight="Cocino una vez y tengo comida lista para toda la semana" data-id="element-349" />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-350">
        <div className="max-w-3xl mx-auto" data-id="element-351">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-352">
            Preguntas Frecuentes
          </h2>
          <FAQAccordion data-id="element-353" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-354">
        <div className="max-w-3xl mx-auto" data-id="element-355">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-356">
            No se trata solo de comida
          </h2>
          <div className="text-xl text-gray-300 mb-10 leading-relaxed space-y-2" data-id="element-357">
            <p data-id="element-358">Se trata de tranquilidad.</p>
            <p data-id="element-359">Se trata de confianza.</p>
            <p data-id="element-360">Se trata de seguridad.</p>
          </div>

          <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-361">
            Se trata de acompañar a tu bebé en una de las etapas más importantes
            de su desarrollo.
          </p>

          <p className="text-2xl text-white font-bold mb-4" data-id="element-362">Y hacerlo bien.</p>

          <p className="text-xl text-gray-300 mb-10 leading-relaxed italic" data-id="element-363">
            Porque cuando sabes qué hacer, todo se vuelve más simple.
          </p>

          <a href={SECTION_LINK} className="inline-flex flex-col items-center justify-center px-12 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1" data-id="element-364">
            <span className="text-lg md:text-xl font-bold uppercase tracking-normal" data-id="element-365">
              👉 QUIERO EL SISTEMA AHORA
            </span>
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 bg-black text-gray-500 text-center text-sm" data-id="element-366">
        <p data-id="element-367">© 2024 Kit Recetas para Bebé. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-368">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}